import styled from 'styled-components'

export const Content = styled.div`
  width: min(1260px, calc(100% - 40px));
  margin: 0 auto;
  padding: 38px 0 60px;

  @media (max-width: 720px) {
    width: calc(100% - 20px);
    padding: 18px 0 34px;
  }
`

export const Header = styled.div`
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  h1 {
    margin: 0;
    color: #202633;
    font-size: 25px;
  }

  p {
    margin: 5px 0 0;
    color: #7a8390;
    font-size: 12px;
  }

  > button {
    min-height: 40px;
    padding: 0 14px;
    border: 0;
    border-radius: 9px;
    background: #e90000;
    color: #fff;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-weight: 800;
    cursor: pointer;
  }
`

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  gap: 16px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`

export const ListPanel = styled.aside`
  padding: 16px;
  border: 1px solid #e3e6eb;
  border-radius: 14px;
  background: #fff;

  h2 {
    margin: 0 0 12px;
    font-size: 15px;
  }
`

export const ShowcaseSummary = styled.div`
  margin-bottom: 12px;
  padding: 11px 12px;
  border: 1px solid #eceff2;
  border-radius: 10px;
  background: #fafbfc;

  strong,
  span,
  small {
    display: block;
  }

  strong {
    color: #343b46;
    font-size: 10px;
  }

  span {
    margin-top: 4px;
    color: #e90000;
    font-size: 10px;
    font-weight: 800;
  }

  small {
    margin-top: 5px;
    color: #8a929e;
    font-size: 9px;
    line-height: 1.4;
  }
`

export const PostRow = styled.button`
  width: 100%;
  padding: 12px;
  border: 0;
  border-bottom: 1px solid #edf0f3;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  text-align: left;
  cursor: pointer;

  &[data-active='true'] {
    background: #fff4f4;
  }

  div {
    min-width: 0;
  }

  span,
  small,
  strong {
    display: block;
  }

  span {
    color: #e90000;
    font-size: 8px;
    font-weight: 900;
    text-transform: uppercase;
  }

  strong {
    margin: 4px 0;
    overflow: hidden;
    color: #29303a;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  small {
    color: #9299a3;
    font-size: 9px;
  }
`

export const DeleteButton = styled.button`
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  border: 1px solid #eceff2;
  border-radius: 8px;
  background: #fff;
  color: #a4aab3;
  cursor: pointer;

  &:hover {
    color: #e90000;
  }
`

export const FormPanel = styled.section`
  padding: 20px;
  border: 1px solid #e3e6eb;
  border-radius: 14px;
  background: #fff;
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`

export const Field = styled.div<{ $wide?: boolean }>`
  grid-column: ${({ $wide }) => ($wide ? '1 / -1' : 'auto')};

  label {
    display: block;
    margin-bottom: 6px;
    color: #515866;
    font-size: 10px;
    font-weight: 800;
  }

  input,
  select,
  textarea {
    width: 100%;
    padding: 10px 11px;
    border: 1px solid #dfe3e8;
    border-radius: 8px;
    background: #fff;
    color: #2d333d;
    font: inherit;
    font-size: 12px;
    outline: none;
  }

  textarea {
    resize: vertical;
  }
`

export const FieldHelp = styled.small`
  display: block;
  margin-top: 5px;
  color: #8a929e;
  font-size: 9px;
  line-height: 1.4;
`

export const UploadRow = styled.div`
  display: flex;
  gap: 8px;

  > input {
    flex: 1;
  }

  > label {
    margin: 0;
    padding: 0 12px;
    border: 1px solid #dfe3e8;
    border-radius: 8px;
    display: flex;
    align-items: center;
    background: #f7f8fa;
    color: #4e5662;
    cursor: pointer;
  }
`

export const Check = styled.label`
  min-height: 38px;
  margin: 0 !important;
  display: flex !important;
  align-items: center;
  gap: 8px;
  font-weight: 600 !important;

  input {
    width: auto !important;
  }
`

export const Actions = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 9px;

  button {
    min-height: 40px;
    padding: 0 15px;
    border: 0;
    border-radius: 8px;
    background: #e90000;
    color: #fff;
    font-size: 11px;
    font-weight: 800;
    cursor: pointer;
  }

  button.secondary {
    border: 1px solid #dfe3e8;
    background: #fff;
    color: #555e6b;
  }
`

export const Empty = styled.div`
  padding: 24px 10px;
  color: #8a929e;
  font-size: 11px;
  text-align: center;
`

export const ConfirmOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 3000;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(16, 20, 27, 0.58);
`

export const ConfirmDialog = styled.div`
  width: min(440px, 100%);
  padding: 28px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(16, 20, 27, 0.24);

  h2 {
    margin: 14px 0 8px;
    color: #202633;
    font-size: 21px;
  }

  p {
    margin: 0;
    color: #68717d;
    font-size: 13px;
    line-height: 1.55;
  }

  strong {
    color: #2d333d;
  }
`

export const ConfirmIcon = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff0f0;
  color: #d52a32;
  font-size: 17px;
`

export const ConfirmActions = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  button {
    min-height: 42px;
    padding: 0 16px;
    border: 0;
    border-radius: 9px;
    font-size: 11px;
    font-weight: 800;
    cursor: pointer;
  }

  button.secondary {
    border: 1px solid #dfe3e8;
    background: #fff;
    color: #555e6b;
  }

  button.danger {
    background: #d52a32;
    color: #fff;
  }

  button:disabled {
    cursor: wait;
    opacity: 0.65;
  }

  @media (max-width: 520px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`
